import AnimatedTreeIcon from "./AnimatedTreeIcon";
import TerminalWordmark from "./TerminalWordmark";
import "./mindGameBrand.css";

export default function MindGameBrand({ animated = true, ready = true, variant = "signature-bars" }) {
  const colorRing = variant === "color-ring";
  return <div className={`mg-brand-lockup${colorRing ? " mg-brand-color-ring" : ""}${animated ? "" : " mg-brand-still"}${ready ? "" : " mg-brand-pending"}`}>
    <AnimatedTreeIcon colorRing={colorRing} />
    <div className="mg-brand-word">
      <TerminalWordmark>
        {!colorRing && <span className="mg-brand-bars" aria-hidden="true"><i /><i /><i /></span>}
      </TerminalWordmark>
    </div>
  </div>;
}
